module.exports = __webpack_public_path__ + "static/media/presense-alternate-logo.03d0d2a8.png";